import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import Bgimg from "@/assets/images/academy/nft-2.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.nft, className)}>
        <img src={Bgimg} />
        <ul>
          <li>
            <div>
              <h2>So what can I do with an NFT?</h2>
              <h4>
                Great question, imagine playing a video game where you play against other players from around the world. Before you play, you get to choose your
                character and maybe what your character wears or looks like. It is possible that you buy an NFT outfit for your character to wear, or a unique
                hairstyle that only your character will have the rights to own. This may seem trivial, but many gamers already pay for extras for their games,
                people already pay more for extra features in their social media, NFT's will help creators be properly reimbursed while users can have a more
                unique, individualised experience.
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
